import { AlertTriangle, Check, Circle, LucideIcon, X } from 'lucide-react';
import { StatusTone } from '@/components/ui/statusTone.ts';
import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { ConsentStatus } from '@/features/dashboard/consentTemplates/types/ConsentStatus.ts';

export const consentStatusLabels: Record<ConsentStatus, string> = {
  [ConsentStatus.ACCEPTED]: 'Zaakceptowana',
  [ConsentStatus.WITHDRAWN]: 'Wycofana',
  [ConsentStatus.OUTDATED]: 'Nieaktualna',
  [ConsentStatus.NOT_ACCEPTED]: 'Niezaakceptowana',
};

export const consentStatusTones: Record<ConsentStatus, StatusTone> = {
  [ConsentStatus.ACCEPTED]: 'success',
  [ConsentStatus.WITHDRAWN]: 'error',
  [ConsentStatus.OUTDATED]: 'warning',
  [ConsentStatus.NOT_ACCEPTED]: 'caution',
};

export const consentStatusIcons: Record<ConsentStatus, LucideIcon> = {
  [ConsentStatus.ACCEPTED]: Check,
  [ConsentStatus.WITHDRAWN]: X,
  [ConsentStatus.OUTDATED]: AlertTriangle,
  [ConsentStatus.NOT_ACCEPTED]: Circle,
};

export const consentStatusTableConfig: EnumTableConfig = Object.fromEntries(
  Object.values(ConsentStatus).map((status) => [
    status,
    toneEnumConfig(consentStatusLabels[status], consentStatusTones[status]),
  ]),
);

export const getConsentStatusLabel = (status: string): string => {
  return consentStatusLabels[status as ConsentStatus] ?? status;
};

export const consentStatusOptions = Object.values(ConsentStatus).map(
  (value) => ({
    value,
    label: consentStatusLabels[value],
  }),
);
